import { ReactNode, useContext } from 'react';
import { Typography } from '@mildang/mui';
import { DocumentContext } from './DocumentContext';

const Title = ({ children }: { children: ReactNode }) => {
  const { variant } = useContext(DocumentContext);

  if (variant === 'dialog') {
    return null;
  }
  return (
    <Typography align="center" variant="h1">
      {children}
    </Typography>
  );
};

export default Title;
